import { Col, Row } from 'antd';
import styled from 'styled-components';
import GlobalButton from 'Components/common/components/GlobalButton';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { actions } from 'Slice/CompaniesSlice';
import { selectCompanySecFilings, selectCompanySecFilingsLoading } from 'Selector/CompaniesSelector';
import NoDataFound from 'Components/common/components/NoDataFound';
import { COMPANIES_ROUTE, NODATAFOUND } from 'Utils/Constants';
import DollarIcon from '../svgIcons/DollarIcon';
import {
  boxShadow,
  primaryColor,
  primaryFont,
  secondaryFont,
  primaryHeadingColor,
  wMBold,
  wMedium,
} from '../../../Utils/utilsStyle';

const Wrapper = styled.div`
  .backButton {
    padding: 20px 38px 20px 0;
  }
  .classForLeftSeparator {
    margin: 0 10px -5px 5px;
  }
  .heading {
    font-size: 18px;
    color: #5E7079;
    font-weight: ${wMBold};
    font-family: ${primaryFont};
    letter-spacing: -0.38;
    line-height: 1 !important;
    margin: 0;
    text-align: start;
  }
  .result {
    font-size: 20px;
    color: ${primaryHeadingColor};
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    letter-spacing: -0.416667;
    line-height: 1.2 !important;
    margin: 0;
    text-align: start;
  }
  .styleForhash{
    margin-left: 40px;
  }
  .resultRow {
    box-shadow: ${boxShadow};
    border-radius: 8px;
    background-color: #fff;
    margin-top: 20px;
    padding: 27px 0;
  }
  .resultRowForSkeleton {
    box-shadow: ${boxShadow};
    border-radius: 8px;
    /* background-color: #fff; */
    margin-top: 20px;
    padding: 27px 0;
  }
  .headingRow {
    padding-bottom: 11px;
    border-bottom: 1px solid #DDDDDD;
  }
`;

const returnResultRow = (
  link: string,
  type: string,
  year: number,
  month: number,
  index: number,
) => (
  <div className="resultRow">
    <Row>
      <Col span={2}>
        <h2 className="result styleForhash">{index}</h2>
      </Col>
      <Col span={16} className="button-column">
        <GlobalButton
          title={link}
          textColor={primaryColor}
          onButtonClick={() => window.open(link)}
          innerSpace="1px 0 0 0"
          fontSize="14px"
        />
      </Col>
      <Col span={2}>
        <h2 className="result">{type}</h2>
      </Col>
      <Col span={2}>
        <h2 className="result">{year}</h2>
      </Col>
      <Col span={2}>
        <h2 className="result">{month}</h2>
      </Col>
    </Row>
  </div>
);

const returnRowSkeleton = () => {
  const skeletons = [];
  for (let i = 0; i < 10; i += 1) {
    skeletons.push(
      <div className="resultRowForSkeleton skeleton-box" style={{ height: '80px', width: '100%' }} />,
    );
  }
  return skeletons;
};

type Dispatch<A> = (value: A) => void;
type Props = {
  setShowSecFilling: Dispatch<boolean>,
};

const Financials = function Financials({ setShowSecFilling }: Props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showSection, setShowSection] = useState(true);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');

  const companyFilings = useSelector(selectCompanySecFilings);
  const companyFilingsLoading = useSelector(selectCompanySecFilingsLoading);

  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;

  useEffect(() => {
    if (companyIdParsed) {
      dispatch(actions.getCompanySecFilings({
        companyId: companyIdParsed,
      }));
    } else {
      navigate(COMPANIES_ROUTE);
    }
  }, []);

  useEffect(() => {
    if (!companyFilingsLoading && !companyFilings?.companyReports?.length) setShowSection(false);
    else setShowSection(true);
  }, [companyFilingsLoading, companyFilings]);

  return (
    <Wrapper className="resolution-fix global-button-fix">

      <div className="backButton">
        <GlobalButton
          title="SEC public forms"
          IconLeft={<DollarIcon />}
          textColor="#424B50"
          fontSize="28px"
          bgColor="transparent"
          innerSpace="0"
          fontFamily={secondaryFont}
          leftSeparator
          leftSeparatorColor="#DDDDDD"
          leftSeparatorClassName="classForLeftSeparator"
          onButtonClick={() => setShowSecFilling(false)}
        />
      </div>

      {showSection
        ? (
          <div>
            <Row className="headingRow">
              <Col span={2}>
                <h2 className="heading styleForhash">#</h2>
              </Col>
              <Col span={16}>
                <h2 className="heading">File Name</h2>
              </Col>
              <Col span={2}>
                <h2 className="heading">Type</h2>
              </Col>
              <Col span={2}>
                <h2 className="heading">Year</h2>
              </Col>
              <Col span={2}>
                <h2 className="heading">Month</h2>
              </Col>
            </Row>
            {
              !companyFilingsLoading
                ? companyFilings?.companyReports?.map((row, index) => returnResultRow(
                  row.link,
                  row.type,
                  row.year,
                  row.month,
                  index + 1,
                )) : returnRowSkeleton()
            }
          </div>
        ) : <NoDataFound title={NODATAFOUND} />}
    </Wrapper>
  );
};

export default Financials;
